import CreatorCreateDecryptPage from "./CreatorCreateDecryptPage";

export default CreatorCreateDecryptPage;
